import { log } from "mathjs";
import { GET_TOTAL_QUEUE_URL, GENERATE_V2_OUTPUT_SCHEMA_URL, GET_ALL_SFTP_SPLITTED_FILES_URL, GET_REPORTS_LOCKBOX_LOG_DETAILS, POST_LOCKBOX_COMMENT_URL, QUEUE_V2_HOLD_USER, QUEUE_V2_RELEASE_STATUS_CHANGE, EDI_VALIDATE_835_LIST_URL, GET_V2_RESEND_OUTPUT_FILE_URL, GENERATE_LOCKBOX_REPORTS, QUEUE_V2_REVERT_JOB, RETRIVE_OUTPUT_GENERATION_LOG_URL, PLB_UPLOAD_JOB_MONITOR, PLB_UPLOAD_SAMPLE_CSV, LOCKBOX_FULL_LIST, DEPOSITE_DATE_CHANGE_URL, LOCKBOX_FILE_SEND, GET_AUTOMATION_JOB_MONITOR, GET_AUTOMATION_JOB_FORCE, JOB_FILE_DOWNLOAD, QUEUE_CLIENT_REJECT_USER, SEND_TO_AUTOMATION_JOB_MONITOR,PRIORITY_LOCKBOX, PARTNER_DROPDOWN_LIST, GET_PDF_URL, UPDATE_JOB_COUNT_ZIP, INITIATE_SNIPPING_PROCESS_URL, XAUTO_JOBMONITOR_COUNTS_URL, GENERATE_MULTIPLE_OPERATION_LOG, GENERATE_MULTIPLE_OUTPUT_FILE_SCHEMA, PROCESS_SNIPPING_QA_IN_PARALLEL, SNIPPING_BATCH_SIZE_INFO, ASSIGN_STAFF_TO_SNIPPING_BATCH, GET_SNIPPING_BATCH_LOGS, MERGE_SNIPPING_BATCH_PAYLOADS, DELETE_SNIPPING_BATCHES, RELEASE_SNIPPING_BATCHES, POST_RESET_LOCKBOX_URL, GET_RESET_LOCKBOX_LOG_URL } from "../../api";
import { CLIENT_JOB_HISTORY_URL, EXPORT_JOB_MONITOR_URL, REJECT_JOB_API, GENERATE_OPERATION_LOG, GENERATE_OUTPUT_FILE_SCHEMA, GENERATE_OUTPUT_SCHEMA_URL, GENERATE_OUTPUT_XML_SCHEMA_URL, GET_ALL_SFTP_FILES_URL, GET_CHANGE_JOB_TAT_URL, GET_QUEUE_LISTING_URL, GET_USERLIST_DROPDOWN_URL, GET_USER_MANUAL_ASSIGN_URL, GET_V2_QUEUE_LISTING_URL, QUEUE_HOLD_USER, QUEUE_RELEASE_STATUS_CHANGE, RESENT_OUTPUT_SCHEMA_URL, TOGGLE_LOCKBOX_URL, RETRIVE_REJECT_JOB_DETAILS_URL } from "../../api";
import axiosInstance from "../../axiosInstance";


export const getChangeJobTat = (new_tat, job) => onResponse => {
    try {
        axiosInstance.post(GET_CHANGE_JOB_TAT_URL, { new_tat, job })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const ediValidate835List = (outputid) => onResponse => {
    try {
        axiosInstance.get(EDI_VALIDATE_835_LIST_URL + "?outputid=" + outputid)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const fetchQueueListing = (page) => onResponse => {
    try {
        axiosInstance.get(GET_QUEUE_LISTING_URL + "?page=" + page)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const generateOperationLog = (lock_box, skip_hold_check = false, comment = "") => onResponse => {
    try {
        const payload = { lock_box, skip_hold_check };
        if (comment && comment.trim() !== "") {
            payload.comment = comment;
        }
        axiosInstance.post(GENERATE_OPERATION_LOG, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const generateMultipleOperationLog = (lock_box, skip_hold_check = false, comment = "") => onResponse => {
    try {
        const payload = { lock_box, skip_hold_check };
        if (comment && comment.trim() !== "") {
            payload.comment = comment;
        }
        axiosInstance.post(GENERATE_MULTIPLE_OPERATION_LOG, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const generateLockboxReports = (data) => onResponse => {
    try {
        axiosInstance.post(GENERATE_LOCKBOX_REPORTS, data)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const generateOutputZip = (lock_box, skip_hold_check = false, comment = "") => onResponse => {
    try {
        const payload = { lock_box, skip_hold_check };
        if (comment && comment.trim() !== "") {
            payload.comment = comment;
        }
        axiosInstance.post(GENERATE_OUTPUT_FILE_SCHEMA, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const generateMultipleOutputZip = (lock_box, skip_hold_check = false, comment = "") => onResponse => {
    try {
        const payload = { lock_box, skip_hold_check };
        if (comment && comment.trim() !== "") {
            payload.comment = comment;
        }
        axiosInstance.post(GENERATE_MULTIPLE_OUTPUT_FILE_SCHEMA, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
// Pass a single id to recalculate one lockbox, or an array of ids for multiple
export const updatejobCountsZip = (lockbox) => onResponse => {
    try {
        const payload = Array.isArray(lockbox) ? { lockbox_ids: lockbox } : { lockbox_id: lockbox };
        axiosInstance.post(UPDATE_JOB_COUNT_ZIP, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const initiateSnippingProcess = (params) => onResponse => {
    try {
        axiosInstance.post(INITIATE_SNIPPING_PROCESS_URL, params)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};export const getUserlist = (page) => onResponse => {
    try {

        axiosInstance.get(GET_USERLIST_DROPDOWN_URL + "?page=" + page)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getUserManualAssign = (staff, assignedqueue, qa_or_snipping,is_import_job_forcefully) => onResponse => {
    try {
        axiosInstance.post(GET_USER_MANUAL_ASSIGN_URL, { staff, assignedqueue, qa_or_snipping ,is_import_job_forcefully})
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const filterQueueDetails = (props) => onResponse => {
    try {

        const staffs = encodeURIComponent(props?.staff ? props?.staff : "");
        const clients = encodeURIComponent(props?.client ? props?.client : "");
        const facility = encodeURIComponent(props?.facility ? props?.facility : "");
        const status = encodeURIComponent(props?.status ? props?.status : "");
        const document_type = encodeURIComponent(props?.document_type ? props?.document_type : "");
        const client_groups = encodeURIComponent(props?.client_group ? props?.client_group : "");
        const filename = encodeURIComponent(props?.filename ? props?.filename : "");
        const check_number = encodeURIComponent(props?.check_number ? props?.check_number : "");
        const batch_id = encodeURIComponent(props?.batch_id ? props?.batch_id : "");
        const sort_order = encodeURIComponent(props?.sort_order ? props?.sort_order : "");
        const sort_key = encodeURIComponent(props?.sort_key ? props?.sort_key : "");
        const date_from = encodeURIComponent(props?.start_date ? props?.start_date : "");
        const date_to = encodeURIComponent(props?.end_date ? props?.end_date : "");
        const deposit_date_range = date_from && date_to ? date_from + "-" + date_to : "";
        // const deposit_date_range = "09/01/2022-04/28/2023";
        const tat_status = encodeURIComponent(props?.tat_status ? props?.tat_status : "");
        const station = encodeURIComponent(props?.station ? props?.station : "");
        const process_date = encodeURIComponent(props?.process_date ? props?.process_date : "");
        const job_id = encodeURIComponent(props?.job_id ? props?.job_id : "");
        const additional_info_status = encodeURIComponent(props?.additional_info_status ? props?.additional_info_status : "");

        const internal_tat_range =encodeURIComponent( props?.internal_tat ? props?.internal_tat : "");
        const tat_time =encodeURIComponent( props?.tat_time ? props?.tat_time : "");
        const output_generated =encodeURIComponent( props?.output_generated ? props?.output_generated : "");
        const partner = encodeURIComponent(props?.partner ? props?.partner : "");
        const lockbox_file_name = encodeURIComponent(props?.lockbox_file_name ? props?.lockbox_file_name : "");

        // console.log(staffs, clients, status, client_groups, filename, check_number, batch_id, date_from, date_to, ':::::>>>>>>>><<<<<<<<<<::::::::::::');
        
        axiosInstance.get(`${GET_V2_QUEUE_LISTING_URL}?page=${props?.page}&limit=${props?.limit}&staffs=${staffs}&clients=${clients}&facility=${facility}&status=${status}&client_groups=${client_groups}&filename=${filename}&check_number=${check_number}&batch_id=${batch_id}&deopsit_date_range=${deposit_date_range}&sort_order=${sort_order}&sort_key=${sort_key}&tat_status=${tat_status}&station=${station}&processed_date_range=${process_date}&job_id=${job_id}&additional_info_status=${additional_info_status}&internal_tat_range=${internal_tat_range}&tat_time=${tat_time}&output_generated_time=${output_generated}&document_type=${document_type}&partner=${partner}&lockbox_filename=${lockbox_file_name}`)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const filterQueueDetailsAutomation = (props,{ is_download = false } = {}) => onResponse => {
 
    try {
        const clients = props?.client ? props?.client : "";
        const status = props?.status ? props?.status : "";
        const filename = (props?.filename ? props?.filename : "");
        const sort_order = props?.sort_order ? props?.sort_order : "";
        const sort_key = props?.sort_key ? props?.sort_key : "";
        const deposit_date = props?.deposit_date ? props?.deposit_date : "";
        const tat_status = (props?.tat_status ? props?.tat_status : "");
        const job_id= (props?.job_id ? props?.job_id : "");
        const internal_tat_range = props?.internal_tat ? props?.internal_tat : "";
        const lockbox_file_name = (props?.lockbox_file_name ? props?.lockbox_file_name : "");
        const tat_time = (props?.tat_time ? props?.tat_time : "");
        const partner=props?.partner ? props?.partner : "";
        const is_from_alerts=props?.is_from_alerts ? props?.is_from_alerts : "";


        // console.log(staffs, clients, status, client_groups, filename, check_number, batch_id, date_from, date_to, ':::::>>>>>>>><<<<<<<<<<::::::::::::');

        const queryParams = {
        page: props?.page,
        limit: props?.limit,
        clients: Array.isArray(clients) ? clients.join(','):"",
        status: Array.isArray(status) ? status.join(','):"",
        filename: filename,
        sort_order: sort_order,
        sort_key: sort_key,
        tat_status: tat_status,
        deopsit_date_range: deposit_date,
        job_id: job_id,
        is_download: is_download,
        is_from_alerts: is_from_alerts,
        internal_tat_range: internal_tat_range,
        lockbox_file_name: lockbox_file_name,
        tat_time: tat_time,
        partner: Array.isArray(partner) ? partner.join(','):"",
        };


        axiosInstance.get(GET_AUTOMATION_JOB_MONITOR , { params: queryParams }) 
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.error(error,"popopi")

    }

};

export const getXautoMonitorCountsByClients = (props) => onResponse => {
    try {
        const queryParams = {
            page: props?.page,
            limit: props?.limit,
            clients: props?.clients,
            sort_order: props?.sort_order,
            sort_key: props?.sort_key,
            partners:props?.partners
        };

        axiosInstance.get('automation/xauto-monitor-counts-by-clients', { params: queryParams })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};

export const filterTotalQueueDetails = (props) => onResponse => {
    try {

        const staffs = encodeURIComponent(props?.staff ? props?.staff : "");
        const clients = encodeURIComponent(props?.client ? props?.client : "");
        const facility = encodeURIComponent(props?.facility ? props?.facility : "");
        const status = encodeURIComponent(props?.status ? props?.status : "");
        const document_type = encodeURIComponent(props?.document_type ? props?.document_type : "");
        const client_groups = encodeURIComponent(props?.client_group ? props?.client_group : "");
        const filename = encodeURIComponent(props?.filename ? props?.filename : "");
        const check_number = encodeURIComponent(props?.check_number ? props?.check_number : "");
        const batch_id = encodeURIComponent(props?.batch_id ? props?.batch_id : "");
        const sort_order = encodeURIComponent(props?.sort_order ? props?.sort_order : "");
        const sort_key = encodeURIComponent(props?.sort_key ? props?.sort_key : "");
        const date_from = encodeURIComponent(props?.start_date ? props?.start_date : "");
        const date_to = encodeURIComponent(props?.end_date ? props?.end_date : "");
        const deposit_date_range = date_from && date_to ? date_from + "-" + date_to : "";
        // const deposit_date_range = "09/01/2022-04/28/2023";
        const tat_status = encodeURIComponent(props?.tat_status ? props?.tat_status : "");
        const station = encodeURIComponent(props?.station ? props?.station : "");
        const process_date = encodeURIComponent(props?.process_date ? props?.process_date : "");
        const job_id = encodeURIComponent(props?.job_id ? props?.job_id : "");
        const additional_info_status = encodeURIComponent(props?.additional_info_status ? props?.additional_info_status : "");
        const tat_time = encodeURIComponent(props?.tat_time ? props?.tat_time : "");
        const internal_tat_range = encodeURIComponent(props?.internal_tat ? props?.internal_tat : "");
        const output_generated_time = encodeURIComponent(props?.ProcessedOutput_generated_time ? props?.ProcessedOutput_generated_time : "");
        const partner = encodeURIComponent(props?.partner ? props?.partner : "");
        const lockbox_file_name = encodeURIComponent(props?.lockbox_file_name ? props?.lockbox_file_name : "");

        // console.log(staffs, clients, status, client_groups, filename, check_number, batch_id, date_from, date_to, ':::::>>>>>>>><<<<<<<<<<::::::::::::');
        
        axiosInstance.get(`${GET_TOTAL_QUEUE_URL}?page=${props?.page}&limit=${props?.limit}&staffs=${staffs}&clients=${clients}&facility=${facility}&status=${status}&client_groups=${client_groups}&filename=${filename}&check_number=${check_number}&batch_id=${batch_id}&deopsit_date_range=${deposit_date_range}&sort_order=${sort_order}&sort_key=${sort_key}&tat_status=${tat_status}&station=${station}&processed_date_range=${process_date}&job_id=${job_id}&additional_info_status=${additional_info_status}&tat_time=${tat_time}&internal_tat_range=${internal_tat_range}&output_generated_time=${output_generated_time}&document_type=${document_type}&partner=${partner}&lockbox_filename=${lockbox_file_name}` )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const changeQueueReleaseStatus = (id, reason,is_import_job_forcefully) => onResponse => {
    try {
        axiosInstance.post(QUEUE_V2_RELEASE_STATUS_CHANGE, { job: id, comment: reason,is_import_job_forcefully, })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const queueHoldUser = (job_id, reason,is_import_job_forcefully) => onResponse => {
    try {
        axiosInstance.post(QUEUE_V2_HOLD_USER, { job_id: job_id, reason: reason,is_import_job_forcefully })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const generateOutputFileSchema835 = (id) => onResponse => {
    try {
        axiosInstance.post(GENERATE_V2_OUTPUT_SCHEMA_URL, { queues: id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const clientJobHistory = (id) => onResponse => {
    try {
        axiosInstance.get(CLIENT_JOB_HISTORY_URL + "?job_id=" + id)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const generateOutputFileSchema = (id) => onResponse => {
    try {
        axiosInstance.post(GENERATE_V2_OUTPUT_SCHEMA_URL, { queues: id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};

export const generateOutputXmlFileSchema = (id) => onResponse => {
    try {
        axiosInstance.post(GENERATE_OUTPUT_XML_SCHEMA_URL, { job: id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};

export const resentOutputFileSchema = (id) => onResponse => {
    try {
        axiosInstance.post(RESENT_OUTPUT_SCHEMA_URL, { queue: id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};

export const fetchAllLockboxFiles = (props) => onResponse => {
    
    try {
        console.log(props);
        const search = props?.search ? props?.search : "";
        // const filename = filename ? filename : "";
        const client = props?.client ? props?.client : "";
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";
        const status = props?.status ? props?.status : "";
        const received_date_range = props?.received_date_range ? props?.received_date_range : "";
        const application_received_date = props?.application_received_date ? props?.application_received_date : "";
		const facility = props?.facility ? props?.facility : "";
        const tat_time = props?.tat_time ? props?.tat_time : "";


        const is_active = props?.is_active ? props?.is_active : "";
        const partner = props?.partner ? props?.partner : [];


       axiosInstance.get(GET_ALL_SFTP_FILES_URL, {
                    params: {
                        page: props?.page,
                        limit: props?.page_limit,
                        search: search,
                        client: Array.isArray (client) ? client.join(',') : "",
                        deposit_date_range: deposit_date_range,
                        status : Array.isArray (status) ? status.join(',') : "",
                        received_date_range: received_date_range,                 
                        application_received_date: application_received_date,
                        facility:  Array.isArray (facility) ? facility.join(',') : "",
                        is_active: is_active, 
                        tat_time: tat_time,
                        partner: Array.isArray(partner) ? partner.join(',') : '',
                        sort_order: props?.sort_order,
                        sort_key: props?.sort_key,

                    }
                    })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const dwnloadlockboxfiles = (props) => onResponse => {
    try {
        console.log(props,"111");
        const search = props?.search ? props?.search : "";
        // const filename = filename ? filename : "";
        const client = props?.client ? props?.client : "";
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";
        const status = props?.status ? props?.status : "";
        const received_date_range = props?.received_date_range ? props?.received_date_range : "";
        const application_received_date = props?.application_received_date ? props?.application_received_date : "";
        const header_names = props?.header_names ? props?.header_names : "";
        const facility = props?.facility ? props?.facility : "";
        const is_active = props?.is_active ? props?.is_active : "";
        const tat_time = props?.tat_time ? props?.tat_time : "";
        const partner = props?.partner ? props?.partner : [];





        axiosInstance.get(LOCKBOX_FULL_LIST, {
            params: {

                header_names:Array.isArray(header_names) ? header_names.join(',') : "", 
                search: search,
                client: Array.isArray(client) ? client.join(',') : "",
                deposit_date_range: deposit_date_range,
                status: Array.isArray(status) ? status.join(',') : "",
                received_date_range: received_date_range,
                application_received_date: application_received_date,
                facility: Array.isArray(facility) ? facility.join(',') : "",
                is_active: is_active,
                tat_time: tat_time,
                partner: Array.isArray(partner) ? partner.join(',') : '',
                sort_key: props?.sort_key,
                sort_order: props?.sort_order,


            }
        })
        
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};
export const retriveOutputGenerationLog = (lockbox) => onResponse => {
    try {
        axiosInstance.post(RETRIVE_OUTPUT_GENERATION_LOG_URL, { lockbox })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const fetchAllLockboxFilesData = (props) => onResponse => {
  
    try {
        const name = props?.name ? props?.name : "";
        const lock_box_file_name = props?.lock_box_file_name ? props?.lock_box_file_name : "";
        const client = props?.clients ? props?.clients : [];
        const split_user = props?.split_user ? props?.split_user : [];
        const facility = props?.facility ? props?.facility : [];

        const partner = props?.partner ? props?.partner : [];
        const tat_time  = props?.tat_time  ? props?.tat_time  : '';


        // const status = props?.status ? props?.status : "";

        axiosInstance.get(GET_ALL_SFTP_SPLITTED_FILES_URL, {
                        params: {
                            page: props?.page,
                            limit: props?.page_limit,
                            search: name,
                            lock_box_file_name: lock_box_file_name,
                            client: Array.isArray(client) ?  client.join(',') : '',
                            facility: Array.isArray(facility) ?  facility.join(',') : '',
                            split_user: Array.isArray(split_user) ?  split_user.join(',') : '',
                            partner: Array.isArray(partner) ?  partner.join(',') : '',
                            tat_time:tat_time,
                        }
                        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const resendEobOutputFIleSchema = ({lockbox, lockboxes, is_sent_forcefully, comment} ) => onResponse => {
    try {
        const ids = lockboxes || lockbox;
        axiosInstance.post(GET_V2_RESEND_OUTPUT_FILE_URL, { lockboxes: ids, is_sent_forcefully, comment  })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};



export const toggleLockbox = (lock_box, reason) => onResponse => {
    try {
        // console.log(lock_box, reason);

        axiosInstance.post(TOGGLE_LOCKBOX_URL, { lock_box: lock_box, reason: reason })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const lockboxComment = (lock_box, reason) => onResponse => {
    try {
        // console.log(lock_box, reason);

        axiosInstance.post(POST_LOCKBOX_COMMENT_URL, { lock_box: lock_box, reason: reason })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const resetLockbox = (lockbox, comment) => onResponse => {
    try {
        axiosInstance.post(POST_RESET_LOCKBOX_URL, { lockbox: lockbox, comment: comment })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data ?? err);
            });

    } catch (error) {

    }

};

export const downloadResetLockboxLog = (lockbox_id) => onResponse => {
    try {
        axiosInstance.get(GET_RESET_LOCKBOX_LOG_URL + "?lockbox_id=" + lockbox_id)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data ?? err);
            });

    } catch (error) {

    }

};

export const getLockboxLogDetailsReport = (lockbox) => onResponse => {

    try {

        axiosInstance.get(GET_REPORTS_LOCKBOX_LOG_DETAILS + "?lockbox=" + lockbox)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFileUrl = (props) => onResponse => {

    try {

        axiosInstance.post(GET_PDF_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const rejectJobApi = (ids, reason, is_import_job_forcefully) => onResponse => {

    try {

        axiosInstance.post(REJECT_JOB_API, { jobs: ids, reason: reason, is_import_job_forcefully })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.error(error,'error');

    }

};

export const exportJobMonitor = (props) => onResponse => {
    try {
        const staffs = encodeURIComponent(props?.staff ? props?.staff : "");
        const clients = encodeURIComponent(props?.client ? props?.client : "");
        const facility = encodeURIComponent(props?.facility ? props?.facility : "");
        const status = encodeURIComponent(props?.status ? props?.status : "");
        const document_type = encodeURIComponent(props?.document_type ? props?.document_type : "");
        const client_groups = encodeURIComponent(props?.client_group ? props?.client_group : "");
        const filename = encodeURIComponent(props?.filename ? props?.filename : "");
        const check_number = encodeURIComponent(props?.check_number ? props?.check_number : "");
        const batch_id = encodeURIComponent(props?.batch_id ? props?.batch_id : "");
        const sort_order = encodeURIComponent(props?.sort_order ? props?.sort_order : "");
        const sort_key = encodeURIComponent(props?.sort_key ? props?.sort_key : "");
        const date_from = encodeURIComponent(props?.start_date ? props?.start_date : "");
        const date_to = encodeURIComponent(props?.end_date ? props?.end_date : "");
        const deposit_date_range = date_from && date_to ? date_from + "-" + date_to : "";
        // const deposit_date_range = "09/01/2022-04/28/2023";
        const tat_status = encodeURIComponent(props?.tat_status ? props?.tat_status : "");
        const header_names = encodeURIComponent(props?.header_names ? props?.header_names : "");
        const station = encodeURIComponent(props?.station ? props?.station : "");
        const list_type = encodeURIComponent(props?.list_type ? props?.list_type : "");

        const process_date = encodeURIComponent(props?.process_date ? props?.process_date : "");
        const job_id = encodeURIComponent(props?.job_id ? props?.job_id : "");
                const additional_info_status = encodeURIComponent(props?.additional_info_status ? props?.additional_info_status : "");

        const internal_tat = encodeURIComponent(props?.internal_tat ? props?.internal_tat : "");
        const tat_time = encodeURIComponent(props?.tat_time ? props?.tat_time : "");
        const output_generated = encodeURIComponent(props?.output_generated ? props?.output_generated : "");
        const partner = encodeURIComponent(props?.partner ? props?.partner : "");
        const lockbox_file_name = encodeURIComponent(props?.lockbox_file_name ? props?.lockbox_file_name : "");

        axiosInstance.get(`${EXPORT_JOB_MONITOR_URL}?page=${props?.page}&limit=${props?.limit}&staffs=${staffs}&clients=${clients}&facility=${facility}&status=${status}&client_groups=${client_groups}&filename=${filename}&check_number=${check_number}&batch_id=${batch_id}&deopsit_date_range=${deposit_date_range}&sort_order=${sort_order}&sort_key=${sort_key}&tat_status=${tat_status}&header_names=${header_names}&station=${station}&list_type=${list_type}&processed_date_range=${process_date}&job_id=${job_id}&additional_info_status=${additional_info_status}&internal_tat_range=${internal_tat}&tat_time=${tat_time}&output_generated_time=${output_generated}&document_type=${document_type}&partner=${partner}&lockbox_filename=${lockbox_file_name}`)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const revertGeneratedJob = (job_id, reason) => onResponse => {
    try {
        axiosInstance.post(QUEUE_V2_REVERT_JOB, { job: job_id, comment: reason })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const plbBulkUplad = (data) => onResponse => {
    try {
        axiosInstance.post(PLB_UPLOAD_JOB_MONITOR,data, {
            headers: {
                "Content-Type": "multipart/form-data" // Required for file upload
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPlbBulkUpladSample = (data) => onResponse => {
    try {
        axiosInstance.post(PLB_UPLOAD_SAMPLE_CSV,{job:data?.job})
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const changeDepositeDatechangeLockbox =  (lock_id,deposite_date,comment) => onResponse => {
    try {
        axiosInstance.post(DEPOSITE_DATE_CHANGE_URL, {deposite_date:deposite_date,lockbox:lock_id,comment:comment})
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const LockboxFileSent = (selectedRows) => onResponse => {
    try {
        axiosInstance.post(LOCKBOX_FILE_SEND, { lockbox_instances:selectedRows })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};


export const automationJobForce = (selectedRows,reason) => onResponse => {
    try {
        axiosInstance.post(GET_AUTOMATION_JOB_FORCE, { job_ids: selectedRows, reason: reason })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const exportautomation = (props,{ is_download = false ,all_data=false} = {}) => onResponse => {
 
    try {
        const clients = props?.client ? props?.client : "";
        const status = props?.status ? props?.status : "";
        const filename = props?.filename ? props?.filename : "";
        const sort_order = props?.sort_order ? props?.sort_order : "";
        const sort_key = props?.sort_key ? props?.sort_key : "";
        const deposit_date = props?.deposit_date ? props?.deposit_date : "";
        const tat_status = props?.tat_status ? props?.tat_status : "";
        const job_id=props?.job_id ? props?.job_id : "";
        const header_names=props?.header_names ? props?.header_names : "";
        const is_from_alerts=props?.is_from_alerts ? props?.is_from_alerts : "";
        const tat_time=props?.tat_time ? props?.tat_time : "";
        const partner=props?.partner ? props?.partner : "";


        axiosInstance.get(GET_AUTOMATION_JOB_MONITOR + "?page=" + props?.page + "&limit=" + props?.limit + '&clients=' + clients + '&status=' + status + '&filename=' + filename + "&sort_order=" + sort_order + "&sort_key=" + sort_key + "&tat_status=" + tat_status+'&header_names=' + header_names+ '&deopsit_date_range=' + deposit_date +"&job_id=" + job_id +"&is_download=" + is_download +"&all_data=" + all_data+"&tat_time=" + tat_time+"&partner=" + partner+"&is_from_alerts=" + is_from_alerts )
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.error(error,"popopi")

    }

};

export const jobFileDownload = (file) => onResponse => {
    try {
        axiosInstance.get(JOB_FILE_DOWNLOAD + "?file_path=" + file )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const queueClientRejectUser = (job_id, reason,is_import_job_forcefully) => onResponse => {
    try {
        axiosInstance.post(QUEUE_CLIENT_REJECT_USER, { job_id: job_id, reason: reason,is_import_job_forcefully })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const sendToAutomationJobMonitor = (job_id) => onResponse => {
    try {
        axiosInstance.post(SEND_TO_AUTOMATION_JOB_MONITOR, { job_id: job_id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const prioritylockbox=  ({locid,priority}) => onResponse => {
    try {

        axiosInstance.post(PRIORITY_LOCKBOX,   {lockbox:locid,priority:priority })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const partnerDropdown = (page) => onResponse => {
    try {

        axiosInstance.get(PARTNER_DROPDOWN_LIST + "?page=" + page)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const retriveRejectJobDetails = (id) => onResponse => {
    try {
        axiosInstance.get(RETRIVE_REJECT_JOB_DETAILS_URL + "?id=" + id)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};

export const getLockboxSnippingFiles = (props) => onResponse => {
    try {
        const lockbox_id = props?.lockbox_id;
        const is_snippet_file_null = props?.is_snippet_file_null ?? "";
        const file_name = props?.file_name;
        const page = props?.page || 1;
        const page_limit = props?.page_limit || 25;

        const payload = { 
            lockbox_id: lockbox_id,
            page: page,
            limit: page_limit
        };
        if (is_snippet_file_null !== "") {
            payload.status = is_snippet_file_null;
        }
        if (file_name) {
            payload.file_name = file_name;
        }
        
        axiosInstance.post('/snipping/lockbox-snipping-files', payload)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err.response || err);
            });

    } catch (error) {
        console.log(error);
    }
};

export const getXautoJobmonitorCounts = () => onResponse => {
    try {
        axiosInstance.get(XAUTO_JOBMONITOR_COUNTS_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const processQaSnippingInParallel = (staff, assignedqueue, qa_or_snipping,is_import_job_forcefully,batch_size,revert_batch_forcefully) => onResponse => {
    try {
        axiosInstance.post(PROCESS_SNIPPING_QA_IN_PARALLEL, { staff, assignedqueue, qa_or_snipping ,is_import_job_forcefully,batch_size,revert_batch_forcefully})
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSnippingBatchSizeInfo = (assignedqueue) => onResponse => {
    try {
        axiosInstance.get(SNIPPING_BATCH_SIZE_INFO + "?assignedqueue=" + assignedqueue)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const assignStaffToSnippingBatch = (props) => onResponse => {
    try {
        axiosInstance.post(ASSIGN_STAFF_TO_SNIPPING_BATCH, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSnippingBatchLogs = (batch_id) => onResponse => {
    try {
        axiosInstance.get(GET_SNIPPING_BATCH_LOGS + "?batch_id=" + batch_id)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const mergeSnippingBatchPayloads = (job) => onResponse => {
    try {
        axiosInstance.post(MERGE_SNIPPING_BATCH_PAYLOADS, { job })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const deleteSnippingBatches = (job, delete_forcefully = false, comment = '') => onResponse => {
    try {
        axiosInstance.post(DELETE_SNIPPING_BATCHES, { job, ...(delete_forcefully && { delete_forcefully: true, comment }) })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};
export const releaseSnippingBatches = (batches, release_forcefully = false, comment = '') => onResponse => {
    try {
        axiosInstance.post(RELEASE_SNIPPING_BATCHES, { batches, ...(release_forcefully && { release_forcefully: true, comment }) })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);
    }

};